module.exports = require('./Switch');


//////////////////
// WEBPACK FOOTER
// ./node_modules/_rc-switch@1.8.0@rc-switch/es/index.js
// module id = 707
// module chunks = 0 1